import { GridCellProps } from '@progress/kendo-react-grid';
import { AdminProfileInfo } from 'app/components/AdminProfileInfo';

type Props = {
  className?: string;
  e: GridCellProps;
  onClick?: (e) => void;
};

const TeamResultName = ({ className, e, onClick }: Props) => {
  const data = e.dataItem;
  return (
    <td className={className ?? ''}>
      <AdminProfileInfo src={data?.teamImageUrl} name={data?.teamName} />
    </td>
  );
};

export default TeamResultName;
